import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="not-found-container">
      {/* Floating farm decorations */}
      <div className="nf-decor nf-decor-leaf" aria-hidden="true">
        <svg width="60" height="60" viewBox="0 0 60 60">
          <path
            d="M30 5 Q45 20 40 40 Q30 55 20 40 Q15 20 30 5Z"
            fill="currentColor"
            opacity="0.15"
          />
        </svg>
      </div>
      <div className="nf-decor nf-decor-wheat" aria-hidden="true">
        <svg width="40" height="80" viewBox="0 0 40 80">
          <path d="M20 80 L20 20" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.12" />
          <ellipse cx="20" cy="15" rx="6" ry="10" fill="currentColor" opacity="0.1" />
          <ellipse cx="12" cy="25" rx="5" ry="8" fill="currentColor" opacity="0.08" transform="rotate(-20 12 25)" />
          <ellipse cx="28" cy="25" rx="5" ry="8" fill="currentColor" opacity="0.08" transform="rotate(20 28 25)" />
        </svg>
      </div>

      <div className="nf-content">
        <h1 className="nf-code">404</h1>
        <p className="nf-message">
          {t("notFound.message", "Oops! This path doesn't lead to any farm.")}
        </p>
        <p className="nf-submessage">
          {t(
            "notFound.submessage",
            "The page you're looking for may have been moved or doesn't exist."
          )}
        </p>
        <button className="nf-button" onClick={() => navigate("/")}>
          {t("notFound.goHome", "Back to the Village")}
        </button>
      </div>
    </div>
  );
};

export default NotFound;
